import { useNavigate } from "react-router-dom";

import { PageContainer } from "@/features/ui";

import { useAuth } from "@/features/authentication";
import { CenteredLoading, useSnackbar } from "@/features/ui";
import { GoodsReceiptForm } from "@/features/goods-receipts";
import { apiOutletClient, getErrorMessage } from "@/features/shared";

import { Button } from "@mui/material";

export const CreateGoodsReceipt = () => {
  const { outlet } = useAuth();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (formData) => {
    try {
      const { buyerId, ...payload } = formData;

      await apiOutletClient.post("goods-receipts", payload, {
        headers: {
          "Outlet-Id": buyerId,
        },
      });
      navigate(-1);
    } catch (error) {
      const metaError = error.response?.data?.meta?.error;

      if (
        metaError &&
        typeof metaError === "object" &&
        metaError.sellerReferenceNumber
      ) {
        // Friendlier copy for the duplicate delivery-note validation error.
        showSnackbar("No Surat Jalan sudah ada");
      } else {
        showSnackbar(getErrorMessage(error));
      }

      throw error;
    }
  };

  if (!outlet) {
    return <CenteredLoading />;
  }

  return (
    <PageContainer
      maxWidth="xl"
      title="Buat Penerimaan Barang"
      breadcrumbs={[
        { title: "Penerimaan Barang", path: "/procurement/goods-receipts" },
        { title: "Tambah" },
      ]}
    >
      <GoodsReceiptForm
        onSubmit={handleSubmit}
        defaultValues={{
          buyer: outlet,
        }}
        renderActionButton={({ isSubmitting }) => (
          <Button
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Tambah
          </Button>
        )}
      />
    </PageContainer>
  );
};
